// @file Handles JWT

interface TokenPayload {
  user_id: string
  iss: string
  exp: number
}

export function getPayloadFromToken(t: string): TokenPayload {
  return JSON.parse(window.atob(t.split('.')[1]))
}

export function isTokenExpired(t: string): boolean {
  const payload = getPayloadFromToken(t)
  const exp = payload.exp
  return Date.now() >= exp * 1000
}
